import { documentApi } from '../../api';
import { DocumentSequenceFilter, DocumentSequenceForm } from '../../types/document/DocumentSequenceTypes';

const DocumentSequenceService = {
    /**
     * Registra una nueva secuencia documental
     * POST /api/document-sequences
     */
    create: async (data: DocumentSequenceForm) => {
        const response = await documentApi.add(data);
        return response.data;
    },

    /**
     * Actualiza el correlativo actual
     * PUT /api/document-sequences/{id}/current-number
     */
    updateCurrentNumber: async (id: number, newNumber: number) => {
        const response = await documentApi.modifyPathVariable(
            `${id}/current-number/${newNumber}`
        );
        return response.data;
    },

    /**
     * Obtiene una lista paginada de secuencias filtradas
     * POST /api/document-sequences/filtered?page=X&size=Y
     */
    getFiltered: async (
        filter: DocumentSequenceFilter,
        page = 0,
        size = 10,
        sort = 'authorizedFrom,desc'
    ) => {
        const response = await documentApi.addCustom(
            `/filtered?page=${page}&size=${size}&sort=${sort}`,
            filter
        );
        return response.data;
    },

    /**
     * Obtiene una secuencia por su ID
     * GET /api/document-sequences/{id}
     */
    getById: async (id: number) => {
        const response = await documentApi.fetchById(id);
        return response.data;
    },

    /**
     * Obtiene las secuencias activas
     * GET /api/document-sequences/active
     */
    getActiveSequences: async () => {
        const response = await documentApi.fetchCustom('/active');
        return response.data;
    },
};

export default DocumentSequenceService;
